import  { Logger } from 'aws-amplify';
const logger = new Logger('Cart','INFO');


export const PriceMixIns = {
    data () {
        return {
            testData:500
        }
    },
    methods:{
        mixintest(){
            console.log("hello world")
            logger.info("loggerMsg")
            logger.info(this.totalPrice)
            logger.info(this.testData)
        },
        getCurrencyFormatted: function (naked){
            let res
            if(this.lang && this.currency){
                const currencyFormatter = new Intl.NumberFormat(this.lang,{style:'currency',
                    currency:this.currency});
                res = currencyFormatter.format(naked)
            }

            return res
        },
    }
}